module.exports = __webpack_public_path__ + "static/raven-bow-92009e5e673f8eeee2ed5144b9837979.png";